// This file was automatically generated from clickItem.html.
// Please don't edit this file by hand.

goog.provide('el8.template.clickItem');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.data.physicians');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.clickItem.selectedPhysician = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8CardWrapSmall">');
  el8.template.data.physicians.icon(opt_data.physician, output);
  output.append('<span class="el8Bold">', soy.$$escapeHtml(opt_data.physician.name), '</span>');
  if (opt_data.physician.isEConfirmed) {
    el8.template.data.physicians.verifiedCheck(null, output);
  }
  if (opt_data.physician.specialties.length) {
    output.append('<p class="el8ItalicText">');
    el8.template.data.physicians.specialtyList(opt_data.physician, output);
    output.append('</p>');
  }
  output.append('</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.clickItem.manualPhysician = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8CardWrapSmall"><span class="el8PencilIcon"></span><span class="el8Bold">', soy.$$escapeHtml(opt_data.text), '</span></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.clickItem.selectedDetailedPhysician = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8CardWrap">');
  el8.template.data.physicians.icon(opt_data.physician, output);
  output.append('<a class="el8Link el8ContactEditLink edit-trigger padr15" data-id="', soy.$$escapeHtml(opt_data.physician.id), '">Edit</a><span class="el8Bold">', soy.$$escapeHtml(opt_data.physician.name), '</span>');
  if (opt_data.physician.isEConfirmed) {
    el8.template.data.physicians.verifiedCheck(null, output);
  }
  if (opt_data.physician.specialties.length) {
    output.append('<p class="el8ItalicText">');
    el8.template.data.physicians.specialtyList(opt_data.physician, output);
    output.append('</p>');
  }
  output.append((opt_data.physician.ssClinicName) ? '<p class="el8PLText">' + soy.$$escapeHtml(opt_data.physician.ssClinicName) + '</p>' : '', (opt_data.physician.addressLine || opt_data.physician.cityStateZip) ? '<p>' + soy.$$escapeHtml(opt_data.physician.addressLine) + ((opt_data.physician.addressLine) ? ' ' : '') + soy.$$escapeHtml(opt_data.physician.cityStateZip) + '</p>' : '', (opt_data.physician.phone || opt_data.physician.fax || opt_data.physician.email || opt_data.physician.directAddress) ? '<p>' + ((opt_data.physician.phone) ? 'T: ' + soy.$$escapeHtml(opt_data.physician.phone) + ((opt_data.physician.fax || opt_data.physician.directAddress || opt_data.physician.email) ? ', ' : '') : '') + ((opt_data.physician.fax) ? 'F: ' + soy.$$escapeHtml(opt_data.physician.fax) + ((opt_data.physician.directAddress || opt_data.physician.email) ? ', ' : '') : '') + ((opt_data.physician.directAddress) ? 'D: ' + soy.$$escapeHtml(opt_data.physician.directAddress) + ((opt_data.physician.email) ? ', ' : '') : '') + ((opt_data.physician.email) ? 'E: ' + soy.$$escapeHtml(opt_data.physician.email) : '') + '</p>' : '', '</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.clickItem.manualDetailedPhysician = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8CardWrapSmall"><span class="el8PencilIcon"></span><span class="el8Bold">', soy.$$escapeHtml(opt_data.text), '</span><a class="el8Link el8ContactEditLink edit-trigger padr15" data-text="', soy.$$escapeHtml(opt_data.text), '">Add Details</a></div>');
  if (!opt_sb) return output.toString();
};
